import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';

import { IState, createStore } from '../../../shared/store';
import { createMakeRequest } from '../../../shared/utils/make_request';
import { createBookingContext } from '../pikBooking';

export function createAppState() {
  const config = getConfig();

  const defaultState = config.getStrict<IState>('defaultState');

  /**
   * Это эксперимент для слоно-топа
   */
  // TODO: не забыть удалить, если неудачно закончится
  // tslint:disable-next-line:no-any
  (defaultState.offerData.offer as any).isSlonoTop = window.location.hash === '#slono-top';

  const httpApi = getHttpApi();
  const makeRequest = createMakeRequest(httpApi);

  return createStore({
    config,
    httpApi,
    logger: getLogger(),
    makeRequest,
    pikBookingContext: createBookingContext(),
    telemetry: getTelemetry(),
  }, defaultState as IState, true);
}
